import { Status } from "../types/common"

export const isNotStarted = (status: Status) => status === Status.NOT_STARTED
export const isInprogress = (status: Status) => status === Status.IN_PROGRESS
export const isCompleted = (status: Status) => status === Status.COMPLETED
export const isRejected = (status: Status) => status === Status.REJECTED
